import React from 'react'
import { lifecycle } from 'recompose'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Table from '../../../table/component/Table'
import getColumnList from './customer-column-list'
import {COUNTRY_CODE_LIST, LANGUAGE_LIST} from '../../../internationalization/const'
import TableColumnSelector from "../../../table/component/TableColumnSelector"

const CustomerSearch = ({
    tableData,
    changeFilter,
    toggleSort,
    toggleMultiSort,
    gotoPage,
    navigateToCustomer,
    isTablet,
    isPartner,
    toggleColumnVisibility,
}) => {
    const columnList = getColumnList(isTablet, isPartner)

    return (
        <ContentBox title="Customer">
            <TableColumnSelector
                resultsNumber={tableData.objectList.length}
                hiddenColumns={tableData.hiddenColumns}
                columnList={columnList}
                toggleColumnVisibility={toggleColumnVisibility}
            />

            <Table
                {...tableData}
                filterSetting={
                    {
                        language: languageSimplifierFilterSetting,
                        countryCode: {
                            type: 'select',
                            valueList: COUNTRY_CODE_LIST,
                        },
                    }
                }
                changeFilter={changeFilter}
                toggleSort={toggleSort}
                toggleMultiSort={toggleMultiSort}
                gotoPage={gotoPage}
                idProperty="id"
                columnList={columnList}
                onRowClick={customer => {
                    navigateToCustomer(customer.id)
                }}
            />
        </ContentBox>
    )
}

CustomerSearch.propTypes = {
    tableData: PropTypes.object.isRequired,
    navigateToCustomer: PropTypes.func.isRequired,
    isTablet: PropTypes.bool.isRequired,
    changeFilter: PropTypes.func,
    toggleSort: PropTypes.func,
    toggleMultiSort: PropTypes.func,
    gotoPage: PropTypes.func,
    isPartner: PropTypes.bool,
}

/*
 * Filtering happens on the server, so we need to feed in server-stored values
 * To achieve filtering by locale string snippets, we need a `select` type table filter,
 *  where we display language families (English) and do filtering by the corresponding locale snippet
 */
const languageSimplifierFilterSetting = {
    type: 'select',
    valueList: LANGUAGE_LIST.filter(entry => (entry.id !== '')),
}
export default withLayout(lifecycle({
    componentDidMount () {
        this.props.initialTableSettings()
        this.props.initialTableQuery()
    },
})(CustomerSearch))



// WEBPACK FOOTER //
// ./src/modules/customer/component/search/CustomerSearch.js